// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const baxcalibur: PokeData = {
  "id": 998,
  "name": "baxcalibur",
  "height": 21,
  "weight": 2100,
  "base_experience": 300,
  "types": [
    PokeType.DRAGON,
    PokeType.ICE
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "leer",
    "bite",
    "ice-beam",
    "focus-energy",
    "icy-wind",
    "dragon-breath",
    "crunch",
    "dragon-claw",
    "ice-shard",
    "ice-fang",
    "dragon-tail",
    "icicle-crash",
    "breaking-swipe",
    "glaive-rush",
    "snowscape"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "dragon-breath",
    "crunch",
    "dragon-claw",
    "ice-shard",
    "ice-fang",
    "hailstorm",
    "sheer-cold",
    "dragon-fang",
    "great-roar",
    "dragon-vortex"
  ],
  "evolution_chain": {
    "id": 527,
    "item": null,
    "species": [
      {
        "name": "frigibax",
        "order": 949,
        "types": [
          PokeType.DRAGON,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "arctibax",
        "order": 950,
        "types": [
          PokeType.DRAGON,
          PokeType.ICE
        ],
        "evolves_from_species_id": 996,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "baxcalibur",
        "order": 951,
        "types": [
          PokeType.DRAGON,
          PokeType.ICE
        ],
        "evolves_from_species_id": 997,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 54,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 104,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
